import React from "react";
import { Card, Col, Container, Row } from "reactstrap";
import BreadCrumb from "../../../../Components/Common/BreadCrumb";
import UsersList from "./UserList";
import UserFilter from "./UserFilter";

const Users = () => {
  const breadcrumbItems = [
    { title: "Team", link: "" },
    { title: "User", link: "/team/user" },
  ];

  // document.title="USERS"
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb items={breadcrumbItems} />
          <Card>
            <UsersList />
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Users;
